import { ICostBooking, ICostRevDetails } from 'reducers/bookings/models';
import {
	IChargeItem,
	IEquipments,
	IExportJob,
	ICostRevenue,
} from 'reducers/cbl/models';

export const CostRevEmptySubs: ICostRevDetails = {
	essoRateDetailsSplitId: 0,
	essoRateDetailId: 0,
	bookingSplitId: 0,
	quantity: 0,
	bookingId: 0,
	bookingNumber: '',
	documentId: 0,
	documentNumber: '',
	cblId: 0,
	cblNumber: '',
	equipmentId: 0,
	equipmentNumber: '',
};
export const CostRevEmptyData: ICostBooking = {
	id: 0,
	handleError: false,
	chargeItem: 0,
	uom: '',
	quantity: 0,
	total: 0,
	totalLocalCurrency: 0,
	payToParty: '',
	payToPartyName: '',
	billToParty: '',
	billToPartyName: '',
	partyDetails: '',
	itemNumber: '',
	itemType: '',
	itemCategory: '',
	others: '',
	carrierServiceContractCost: '',
	contractNumberCost: '',
	contractItemNumberCost: '',
	infoRecordCost: '',
	pricingDate: '',
	profitCenterRevenue: '',
	payTermsRevenue: '',
	materialCode: '',
	materialDescription: '',
	modsStringRevenue: '',
	purOrgCost: '',
	rate: 0,
	rowVersion: '',
	condCurrency: 'CNY',
	localCurrency: 'CNY',
	icbIndicator: '-',
	exchangeRate: 1.0001,
	isDeleted: false,
	passThrough: '',
	errorReason: '',
	contractNumberRevenue: '',
	contractTypeRevenue: '',
	insertBy: '',
	insertDate: '',
	updatedBy: '',
	updatedDate: '',
	displayDistribution: false,
	distribution: 2,
	status: '',
	costAndRevenueDetails: [],
	children: [],
	serviceRenderedAt: '',
	vatPartner: '',
	vatPartnerReasonCodeNo: '',
	Applicability: '',
	ChargeType: '',
	dynamicFields: '',
	AdhocContractualAmendmentIdentifier: '',
	AthenaRateIdentifier: '',
	specialPricingCondition: 'N',
	netValue: 0.00,
	vendorReference: '',
	VatPartnerIdentifier: '',
	VatPartnerValueError: '',
	ServiceProvider: '',
    chargeValidityBased: '',
    contractStartDate: '',
    contractEndDate: '',
    secondaryRateIdentifier: '',
    financialReferenceNumber : '',
    externalBookingNumber: '',
    externalItemNumber: '',
    internalReferenceNumber: '',
    isReadOnly: false,
    division: 'SCM',
};

// For new CBL
export const EmptyQuantityDistribution = {
	bookingSplitId: 0,
	essoRateDetailSplitId: 0,
};
export const CostRevSplitEmptyData: ICostRevenue = {
	partyDetails: '',
	party: '',
	icbIndicator: '-',
	quantityDistributions: [],
	exportJobId: 0,
};

export const EmptySplits: IEquipments = {
	id: 0,
	bookingSplitId: 0,
	equipmentNumber: '',
	containerSizeType: '',
	substitutionSizeType: '',
	primaryDocumentNumber: '',
	bookingNumber: '',
	quantity: '',
	select: false,
};

export const EmptyExportJob: IExportJob = {
	exportJobId: 0,
	finNumber: '',
	splits: [],
	party: '',
	icbIndicator: '-',
	partyDetails: '',
};

export const CostRevNewEmptyData: IChargeItem = {
	id: 0,
	materialCode: '',
	materialDescription: '',
	quantity: 0,
	unitOfMeasure: '',
	rate: 0,
	condCurrency: '',
	localCurrency: '',
	exchangeRate: 1.0001,
	distribution: 2,
	essoRateDistributions: [],
	errorReason: '',
	handleError: false,
	children: [],
	itemType: '',
	displayDistribution: false,
	totalLocalCurrency: '',
	total: '',
	delete: '',
	isSameParty: false,
	updateChildrenStatus: false,
	party: '',
	partyDetails: '',
	icbIndicator: '-',
	partyName: '',
	isOthers: false,
	others: '',
	passThrough: '',
	serviceRenderedAt: '',
	vatPartner: '',
	vatPartnerReasonCodeNo: '',
};
